<template>
  <div class="step-container scrollPosition haus-step-7a">
    <div class="step-header">
      <h2 class="step-title">Grundstück</h2>
      <p class="step-text">
        Steht die Wohnung auf einem gepachtetem Grundstück?
      </p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <ActionBox
          class="box-item small-icon-w-50"
          text="Gepachtetes Grundstück"
          @click="setRechtsform(20)"
          :iconDefault="require('@/assets/icons/Svgs/wohnung_gepachtetes_grundstueck.svg')"
          :iconHover="require('@/assets/icons/Svgs/wohnung_gepachtetes_grundstueck_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Nicht gepachtet"
          @click="setRechtsform(10)"
          :iconDefault="require('@/assets/icons/Svgs/not-existent.svg')"
          :iconHover="require('@/assets/icons/Svgs/not-existent_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row align-items-center">
        <div class="col-md-4 col-6">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from "@/components/shared/ActionBox.vue";
import {
  getFromStorage,
  saveToStorage,
} from "@/utils.js";
export default {
  name: "dg-wohnung-step-3",
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        indexRechtsform: { value: null },
        // flagBalkon: { value: null },
        // flagTerrasse: { value: null },
      },
    };
  },
  methods: {
    setRechtsform(index) {
      this.fields.indexRechtsform.value = index;
      saveToStorage(this.fields);
      this.$router.push("/dg-wohnung-step-4");    },
    goBack() {
      this.$router.push("/dg-wohnung-step-2");    },

  //     if (
  //       isSet(this.fields.flagBalkon.value) ||
  //       isSet(this.fields.flagTerrasse.value)      ) {
  //       this.$router.push("/dg-wohnung-step-7b");
  //     } else {
  //       this.$router.push("/dg-wohnung-step-7a");
  //   }
  // },

  },
  mounted() {
    this.$emit("setStep", "haus", 4);
    getFromStorage(this.fields);
  },
};
</script>
